import { Link } from "react-router-dom";
import styles from "./Home.module.css";

import home_bg_top from "../../assets/img_home_bg_top.png";
import home_bg_fighter from "../../assets/img_home_fighter.png";
import home_bg_bottom from "../../assets/ime_home_bg_bottom.png";
import icon_home_service_off from "../../assets/icon_home_service_off.png";
import icon_home_service_on from "../../assets/icon_home_service_on.png";
import icon_home_payment_off from "../../assets/icon_home_payment_off.png";
import icon_home_payment_on from "../../assets/icon_home_payment_on.png";
import icon_home_customer_off from "../../assets/icon_home_customer_off.png";
import icon_home_customer_on from "../../assets/icon_home_customer_on.png";
import icon_home_login_off from "../../assets/icon_home_login_off.png";
import icon_home_login_on from "../../assets/icon_home_login_on.png";
import icon_home_signin_off from "../../assets/icon_home_signin_off.png";
import icon_home_signin_on from "../../assets/icon_home_signin_on.png";


export default function Home() {
    return (
        <main className={styles.home}>
            {/* Hero Section */}
            <section
                className={styles.homeTop}
                style={{ backgroundImage: `url(${home_bg_top})` }}
            >
                <div className={styles.homeTopContent}>
                    <h1 className={styles.homeTopTitle}>
                        FirST SIM
                        <span className={styles.homeTopSubtitle}>
                            (Fire Spread real-Time SIMulation)
                        </span>
                    </h1>
                    <p className={styles.homeTopLead}>
                        화재 시뮬레이션 활용성 강화를 위한, <br />
                        화재 확산 실시간 시뮬레이션
                    </p>
                    <Link to="/service" className={styles.homeBtnPrimary}>
                        바로가기
                    </Link>
                </div>
                <div className={styles.homeTopMock} aria-hidden />
            </section>

            {/* Summary Section */}
            <section className={styles.homeSummary}>
                <div className={styles.homeSummaryIllustration}>
                    <img src={home_bg_fighter} alt="현장 대응 중인 소방관 일러스트" />
                </div>
                <div className={styles.homeSummaryContent}>
                    <h2 className={styles.homeSummaryTitle}>
                        실시간 시뮬레이션 기반의 화재 확산 예측
                    </h2>
                    <p className={styles.homeSummaryDesc}>
                        화재 확산 예측과 피난 경로 안내를 실시간으로 제공합니다.
                        건물 단위 시뮬레이션, 층별 뷰, 위험도 지표, 대피 동선 제안까지 한 번에 확인하세요.
                    </p>
                    <Link to="/service" className={`${styles.homeBtnPrimary} ${styles.homeSummaryCta}`}>
                        바로가기
                    </Link>
                </div>
            </section>

            {/* Service Area */}
            {/* <section
                className={styles.homeServiceArea}
                style={{ backgroundImage: `url(${home_bg_bottom})` }}
            >
                <div className={styles.homeSectionTitle}>Service Area</div>

                <div className={styles.homeCardGrid}>
                    {[
                        { to: "/service", off: icon_home_service_off, on: icon_home_service_on, label: "서비스안내" },
                        { to: "/pricing", off: icon_home_payment_off, on: icon_home_payment_on, label: "요금안내" },
                        { to: "/support", off: icon_home_customer_off, on: icon_home_customer_on, label: "고객지원" },
                        { to: "/login", off: icon_home_login_off, on: icon_home_login_on, label: "로그인" },
                        { to: "/signup", off: icon_home_signin_off, on: icon_home_signin_on, label: "회원가입" },
                    ].map((card) => (
                        <Link
                            key={card.label}
                            to={card.to}
                            className={styles.homeCard}
                            style={{
                                "--icon-off": `url(${card.off})`,
                                "--icon-on": `url(${card.on})`,
                            }}
                        >
                            <span className={styles.srOnly}>{card.label}</span>
                            <div className={styles.homeCardIcon} aria-hidden />
                        </Link>
                    ))}
                </div>
            </section> */}
        </main>
    );
}
